import { render } from "./FacilityMappingModal.vue?vue&type=template&id=4c8790a8&ts=true"
import script from "./FacilityMappingModal.vue?vue&type=script&lang=ts"
export * from "./FacilityMappingModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__